// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"SectionTitle_sectionWrapper__aeJtU","title":"SectionTitle_title__9o_UO","badge":"SectionTitle_badge__W4eWq","description":"SectionTitle_description__K79bh"};